export enum OnyxTextTransform {
  LOWERCASE = 'lowercase',
  UPPERCASE = 'uppercase',
  TITLECASE = 'titlecase',
  REMOVE_WHITESPACES = 'remove-whitespaces',
}
